import { removeDupes, cleanObject } from '../utils/helpers';

const milestones = (state = {
    items: [],
    fetchInfo: {
        project: {}
    }
}, action) => {
    if (action.error) {
        return state;
    }

    switch (action.type) {
        case 'TEAM_CHANGE':
        case 'RESET_STORE':
            return {
                items: [],
                fetchInfo: {
                    project: {}
                }
            };

        case 'MARK_ALL_FOR_REFETCH':
            return Object.assign({}, state, {
                items: [...state.items.map(milestone => ({
                    ...milestone,
                    shouldRefetch: true
                }))]
            });

        case 'MILESTONES_FETCH_REQUESTED':
            return Object.assign({}, state, {
                fetchInfo: {
                    ...state.fetchInfo,
                    project: {
                        ...state.fetchInfo.project,
                        [action.payload.projectId]: {
                            ...state.fetchInfo.project[action.payload.projectId],
                            loading: true
                        }
                    }
                }
            });

        case 'MILESTONES_FETCH_SUCCEEDED':
            if (!action.payload.milestones) {
                return state;
            }

            return Object.assign({}, state, {
                items: removeDupes([
                    ...action.payload.milestones,
                    ...state.items
                ]),
                fetchInfo: {
                    ...state.fetchInfo,
                    project: {
                        ...state.fetchInfo.project,
                        [action.payload.projectId]: {
                            loading: false,
                            fetched: true
                        }
                    }
                }
            });

        case 'MILESTONES_FETCH_FAILED':
            return Object.assign({}, state, {
                fetchInfo: {
                    ...state.fetchInfo,
                    project: {
                        ...state.fetchInfo.project,
                        [action.payload.projectId]: {
                            loading: false,
                            error: true
                        }
                    }
                }
            });

        // case 'MILESTONE_CREATE_SUCCEEDED':
        case 'MILESTONE_CREATE_REQUESTED':
        case 'MILESTONE_ADD_SOCKET':
            return Object.assign({}, state, {
                items: removeDupes([...state.items, action.payload.milestone])
            });

        case 'MILESTONE_CREATE_FAILED':
            return Object.assign({}, state, {
                items: state.items.filter(milestone => milestone !== action.payload.fragment)
            });

        case 'MILESTONE_CREATE_SUCCEEDED':
            return Object.assign({}, state, {
                items: removeDupes(state.items
                    .map(milestone => {
                        if (milestone === action.payload.fragment) {
                            milestone.id = action.payload.milestoneId;
                        }

                        return milestone;
                    }))
            });

        case 'MILESTONE_FETCH_REQUESTED':
            return Object.assign({}, state, {
                items: [...state.items.filter(milestone => milestone.id !== action.payload.milestoneId), {
                    ...(state.items.find(milestone => milestone.id === action.payload.milestoneId) || {}),
                    id: action.payload.milestoneId,
                    loading: true
                }]
            });

        case 'MILESTONE_FETCH_FAILED':
            return Object.assign({}, state, {
                items: [...state.items.filter(milestone => milestone.id !== action.payload.milestoneId), {
                    id: action.payload.milestoneId,
                    error: true,
                    removed: action.payload.removed
                }]
            });

        case 'MILESTONE_FETCH_SUCCEEDED':
            if (!action.payload.milestone) {
                return state;
            }

            return Object.assign({}, state, {
                items: [...state.items.filter(milestone => milestone.id !== action.payload.milestone.id), action.payload.milestone]
            });

        case 'MILESTONE_UPDATE_REQUESTED':
        case 'MILESTONE_UPDATE_SOCKET':
            return Object.assign({}, state, {
                items: [...state.items].map(milestone => {
                    if (milestone.id === action.payload.milestoneId) {
                        return Object.assign({}, milestone, cleanObject(action.payload.milestoneProps || action.payload.milestone));
                    }

                    return milestone;
                })
            });

        case 'MILESTONES_UPDATE_REQUESTED':
            return Object.assign({}, state, {
                items: [...state.items].map(milestone => {
                    const pair = action.payload.updatePairs.find(({ id }) => milestone.id === id);

                    if (pair) {
                        return Object.assign({}, milestone, cleanObject(pair.props));
                    }

                    return milestone;
                })
            });

        case 'MILESTONE_REMOVE_REQUESTED':
        case 'MILESTONE_REMOVE_SOCKET':
            return Object.assign({}, state, {
                items: [...state.items].map(milestone => {
                    if (milestone.id === action.payload.milestoneId) {
                        return null;
                    }

                    if (milestone.dependency === action.payload.milestoneId) {
                        return {
                            ...milestone,
                            dependency: undefined
                        }
                    }

                    return milestone;
                }).filter(Boolean)
            });

        case 'MILESTONE_VISIBILITY_SET_REQUESTED':
            if (!state.items.some(milestone => milestone.id === action.payload.milestoneId)) {
                return state;
            }

            return Object.assign({}, state, {
                items: [...state.items].map(milestone => {
                    if (milestone.id === action.payload.milestoneId) {
                        return Object.assign({}, milestone, {
                            hidden: !action.payload.visible ? [...(milestone.hidden || []), ...action.payload.roles] : (milestone.hidden || []).filter(r => !action.payload.roles.includes(r))
                        });
                    }

                    return milestone;
                })
            });

        case 'CUSTOM_FIELD_VALUE_SET_REQUESTED':
            if (action.payload.association !== 'milestone' || !state.items.some(milestone => milestone.id === action.payload.associationId)) {
                return state;
            }

            return Object.assign({}, state, {
                items: [...state.items].map(milestone => {
                    if (milestone.id === action.payload.associationId) {
                        return Object.assign({}, milestone, {
                            fields: [...(milestone.fields || []).filter(field => field.id !== action.payload.fieldId), {
                                id: action.payload.fieldId,
                                value: action.payload.value
                            }]
                        });
                    }

                    return milestone;
                })
            });

        case 'CUSTOM_FIELDS_VALUES_FETCH_REQUESTED':
            if (action.payload.association !== 'milestone' || !state.items.some(milestone => milestone.id === action.payload.associationId)) {
                return state;
            }

            return Object.assign({}, state, {
                items: [...state.items].map(milestone => {
                    if (milestone.id === action.payload.associationId) {
                        return Object.assign({}, milestone, {
                            fields: milestone.fields || []
                        });
                    }

                    return milestone;
                })
            });

        case 'CUSTOM_FIELDS_VALUES_FETCH_SUCCEEDED':
            if (action.payload.association !== 'milestone' || !state.items.some(milestone => milestone.id === action.payload.associationId)) {
                return state;
            }

            return Object.assign({}, state, {
                items: [...state.items].map(milestone => {
                    if (milestone.id === action.payload.associationId) {
                        return Object.assign({}, milestone, {
                            fields: action.payload.values
                        });
                    }

                    return milestone;
                })
            });

        case 'RECURSION_RULE_ADD_SOCKET':
            if (!action.payload.rule.source_milestone || !state.items.some(milestone => milestone.id === action.payload.rule.source_milestone)) {
                return state;
            }

            return Object.assign({}, state, {
                items: [...state.items].map(milestone => {
                    if (milestone.id === action.payload.rule.source_milestone) {
                        return Object.assign({}, milestone, {
                            rule: action.payload.rule.id
                        });
                    }

                    return milestone;
                })
            });

        case 'RECURSION_RULE_REMOVE_REQUESTED':
        case 'RECURSION_RULE_REMOVE_SOCKET':
            if (!state.items.some(milestone => milestone.rule === action.payload.ruleId)) {
                return state;
            }

            return Object.assign({}, state, {
                items: [...state.items].map(milestone => {
                    if (milestone.rule === action.payload.ruleId) {
                        return Object.assign({}, milestone, {
                            rule: null
                        });
                    }

                    return milestone;
                })
            });

        case 'PROJECT_REMOVE_REQUESTED':
        case 'PROJECT_REMOVE_SOCKET':
            if (!state.items.some(milestone => milestone.project === action.payload.projectId)) {
                return state;
            }

            return Object.assign({}, state, {
                items: state.items.filter(milestone => !milestone.project || milestone.project !== action.payload.projectId)
            });

        default:
            return state;
    }
}

export default milestones;
